import React from 'react';
import { Helmet } from 'react-helmet';
import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';
import SecurityBadges from './components/SecurityBadges';

const LoginPage = () => {
  return (
    <>
      <Helmet>
        <title>Sign In - Aletheos Daily</title>
        <meta name="description" content="Sign in to your Aletheos Daily account to continue your personal development journey with structured readings and goal tracking." />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <div className="min-h-screen bg-background flex items-center justify-center p-4">
        <div className="w-full max-w-md">
          {/* Main Login Card */}
          <div className="bg-card border border-border rounded-2xl shadow-gentle p-6 lg:p-8">
            {/* Header Section */}
            <LoginHeader />

            {/* Login Form */}
            <LoginForm />

            {/* Security Badges */}
            <SecurityBadges />
          </div>

          {/* Footer Information */}
          <div className="mt-6 text-center">
            <p className="text-sm text-muted-foreground">
              By signing in, you agree to our Terms of Service and Privacy Policy
            </p>
            <p className="text-xs text-muted-foreground mt-2">
              © {new Date()?.getFullYear()} Aletheos Daily. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;